import { render, staticRenderFns } from "./DspPartner.vue?vue&type=template&id=1b302eae&"
import script from "./DspPartner.vue?vue&type=script&lang=js&"
export * from "./DspPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports